const compareSpecifiers = (specifier1, specifier2) => {
  if (!specifier1 && !specifier2) {
    return true;
  }
  return specifier1 === specifier2;
};
export {
  compareSpecifiers
};
